import { x } from '@/style';

import { Card, Text, VStack } from '@ui-furniture/elements';
import { currencyFormatter } from '@ui-furniture/lib/utils/data-transform/currency-formatter';

export const RicsSurveyCard = ({
  level,
  price,
}: {
  level: 2 | 3;
  price: number;
}) => {
  return (
    <>
      <Card w='100%'>
        <x.div
          display='flex'
          alignItems='center'
          position='relative'
          p='lg'
          h='100%'
          overflow='hidden'
          borderRadius='5px'
        >
          <x.img
            src={'/images/survey/rics.svg'}
            alt={`RICS Level ${level} Survey`}
            objectFit={'contain'}
            height='100%'
            position='absolute'
            top='15%'
            right='12px'
            bottom='12px'
            opacity={0.3}
          />
          <x.img
            src={'/images/survey/white-gradient-overlay.png'}
            objectFit={'cover'}
            position='absolute'
            width='100%'
            height='100%'
            top='0'
            right='0'
            left='0'
            bottom='0'
          />
          <VStack position='relative' gap='xs'>
            <Text lineHeight='1' fontWeight='500' fontSize='lg'>
              {`RICS Level ${level} Survey`}
            </Text>
            <Text fontSize='md' fontWeight='500' color='palette-primary'>
              {currencyFormatter.format(price)}
            </Text>
          </VStack>
        </x.div>
      </Card>
    </>
  );
};
